<template>
    <div class="pt-4 col-sm-12">

        <div class="row">

            <div class="col-sm-6">
                <div class="tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center" @click="checkAll(true)">
                    <div>
                        <div><i class="ico ico-check m-0 fs-super color-3"></i></div>
                        <div class="font-weight-600 mt-2 fs-larger">Check-All</div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center" @click="checkAll(false)">
                    <div>
                        <div class="font-weight-600 mt-2 fs-larger">No Show All</div>
                        <div><i class="ico ico-close m-0 fs-super color-6"></i></div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import {eventHub} from '../../../main'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function(){
        },
        props: {
            bulkObject: {
                type: Object
            }
        },
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getBulkSelectedIds'
            ]),
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            checkAll: function(checkin){
                axios.post('/api/booking/BulkCheckIn', {
                    supplierId: this.account.supplierId,
                    bookingIds: this.getBulkSelectedIds,
                    IsToCheckInAll: checkin? true : false,
                    IsToNoShowAll: checkin? false: true,
                    sendNotification: this.bulkObject.deliverNotification,
                }).then(response => {
                    console.log(response);
                    this.$toasted.info(response.data);
                    eventHub.$emit('updateReservationsList', this.getBulkSelectedIds);
                    this.closeModal()
                })
            },
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>
    .tckBtn{
        height: 150px;
    }
</style>



// WEBPACK FOOTER //
// areaCheckin.vue?f79ca090